import React from "react";
import UserInfo from "../../pages/Dashboard/UserInfo";
import TestCard from "../../pages/Dashboard/TestCard";
import Empty from "../../assets/assets/empty.svg";
import { PropTypes } from "prop-types";

const NoDocs = (props) => {
  const {
    isGetting,
    status,
    userType,
    defaultApp,
    certifiedStatus,
    getStatusSuccess,
    appId,
    companyId,
    results,
    resultsLength,
    getStatus,
    categoryChoice,
    testCardStatus,
    dashboardData,
    expired
  } = props;

  return (
    <div>
      <main className="container-body2">
        <UserInfo
          status={status}
          isGetting={isGetting}
          dashboardData={dashboardData}
          defaultApp={defaultApp}
          getStatusSuccess={getStatusSuccess}
        />
      </main>
      <div className="container-body3">
        <div className="dashboard-main">
          <div className="dashboard-main-header">
            <div className="dashboard-main-header-title">
              <span>Products</span>
            </div>
          </div>

          <div className="dashboard-main-content">
            <div className="pos-doc-sec2">
              <div className="empty-dashboard">
                <div className="empty2">
                  <div>
                    <img src={Empty} alt="empty2" />
                  </div>
                  <h1>No Products</h1>
                  <p>
                    You don't have any products yet. To get products, please follow the link below to upload the<br /> required documents.
                  </p>
                  {userType !== "staff" && (
                    <h3>
                      <a href="/confirmation">Apply here for products</a>
                    </h3>
                  )}
                </div>
              </div>

              <div className="testcard-main" style={{ marginTop: "0px" }}>
                <TestCard
                  certifiedStatus={certifiedStatus}
                  status={status}
                  appId={appId}
                  companyId={companyId}
                  userType={userType}
                  results={results}
                  resultsLength={resultsLength}
                  getUserStatus={getStatus}
                  categoryChoice={categoryChoice}
                  testCardStatus={testCardStatus}
                      expired={expired}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

NoDocs.propTypes = {
  isGetting: PropTypes.bool,
  status: PropTypes.array,
  userType: PropTypes.string,
  defaultApp: PropTypes.array,
  certifiedStatus: PropTypes.bool,
  getStatusSuccess: PropTypes.bool,
  appId: PropTypes.number,
  companyId: PropTypes.number,
  results: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
  resultsLength: PropTypes.array,
  getStatus: PropTypes.func,
  categoryChoice: PropTypes.number,
  testCardStatus: PropTypes.number,
  dashboardData: PropTypes.array,
}

export default NoDocs;
